'use client';

import styled from 'styled-components';
import { colors } from '@/styles';

export const CodeBlock = styled.div`
  pre {
    background-color: ${colors.primary.white};
    padding: 10px !important;
    border-radius: 4px;
    margin: 0;
    border: 1px solid ${colors.secondary.lightGray3};
    max-width: 100%;
    overflow: auto;
    /* text-overflow: ellipsis; */
  }
`;
